@import 'styles/mixins';
@import 'styles/blaze/mixins';
@import 'styles/variables';

.toggleContainer {
  display: flex;
  align-items: center;
  margin-left: calc(var(--collab-item-toggle-padding) + var(--collab-item-avatar-size) / 2);
  padding: 6px 0 12px 0;
  position: relative;

  &:focus {
    outline: 0;
  }

  .labelContainer {
    display: flex;
    flex-direction: row;
    justify-content: center;
    align-items: center;
    padding: 2px 2px 2px 4px;
    gap: 4px;
    height: 20px;
    border-radius: 3px;
    background-color: var(--neutral-5);

    &:focus {
      outline: 0;
    }

    &.unread .label {
      color: var(--action-60);
    }

    [data-design-system='blaze'] & {
      color: var(--dark-40);
      &.unread .label {
        color: var(--dark-40);
      }
    }
  }

  .label {
    display: flex;
    gap: 4px;
    @include sm-sohne;
    color: var(--dark-40);

    [data-autopilot-system-redesign='on'] & {
      @include xs-sohne-book;
    }
  }

  &.focus {
    .label {
      box-shadow: 0 0 0 3px #89dcdb, 0 1px 0 rgba(19, 21, 26, 0.12);
      border-radius: 6px;
    }
  }
}

.toggle {
  background: var(--neutral-0);
  border-radius: 50%;
  margin-left: -16px;
  margin-right: 8px;
  height: 0;
  width: 22px;
  color: var(--neutral-40);
  display: flex;
  align-items: center;
  justify-content: center;

  &:after {
    content: '';
    @include transition;
    position: absolute;
    bottom: 20px;
    width: 21px;
    height: 18px;
    margin-left: 17px;
    border-width: 0 0 2px 2px;
    border-style: solid;
    border-color: var(--neutral-5);
    background-color: transparent;
    border-radius: 0 0 0 5px;

    .highlighted & {
      background-color: transparent;
    }
    [data-design-system='blaze'] & {
      width: 20px;
      height: 16px;
    }
  }
}

.toggleContainer {
  &:not(.collapsed) {
    .toggle:after {
      margin-left: -2px;
      bottom: 0px;
      width: 2px;
      height: 38px;
      border-radius: 0;
      [data-design-system='blaze'] & {
        margin-left: -1px;
        width: 2px;
        height: 36px;
      }
    }

    &.isEditing {
      .toggle:after {
        height: 44px;
        [data-design-system='blaze'] & {
          height: 42px;
        }
      }
    }
  }

  &.isEditing {
    .toggle:after {
      height: 24px;
      [data-design-system='blaze'] & {
        height: 26px;
      }
    }
  }
}

.highlighted {
  .toggle:after {
    background-color: transparent;
    border-color: var(--neutral-10);
  }

  .labelContainer {
    background-color: var(--neutral-10);
  }
}

.chevron {
  @include transition;
  margin-top: 1px;
  color: var(--neutral-30);

  &.rotate {
    transform: rotate(-90deg);
  }
}

.unreadDot {
  left: -24px;
}
